import React, { useState } from "react";

const ReferralForm: React.FC = () => {
  const [formData, setFormData] = useState({
    paymentMethod: "",
    email: "",
    address: "",
    country: "",
    state: "",
    zipCode: "",
  });

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Submit logic
    console.log("Form Data:", formData);
  };

  return (
    <div className="p-6 bg-white shadow-md rounded-lg max-w-3xl mx-auto" style={{ padding: '30px', height: '90%', width: '60%', boxShadow: '6px 4px 10px 5px rgba(0, 0, 0, 0.2)' }} >
      <h2 className="text-xl font-bold mb-4" style={{ fontSize: "13px", fontWeight: '500' }}>
        Become a Referral and earn money by directing users to signup with BidVertiser!
      </h2>
      <p className="text-sm mb-6" style={{ fontSize: "12px" }}>
        Simply place a referral button on your site and you will earn money when a user clicks
        on your button and signs as an advertiser or a publisher:
      </p>
      <ul className="text-sm list-disc list-inside mb-6 space-y-2" style={{ fontSize: "12px", width: '60%' }}>
        <li style={{ marginBottom: '10px' }}>
          When a user signs as an advertiser and first spends $10, we’ll credit your account with
          $5. When that same advertiser spends $100, you will be credited with an additional $20.
        </li>
        <li>
          When a user signs as a publisher and first earns $10, we’ll credit your account with
          $10. When that same publisher earns $100, you will be credited with an additional $40.
        </li>
      </ul>
      <p className="text-sm mb-4" style={{ fontSize: "12px", fontWeight: '500s' }}>
        To continue, please provide your payment information. We issue payments either by check
        or directly to your PayPal account:
      </p>
      <form onSubmit={handleSubmit}>
        <div style={{ display: 'flex', gap: '100px', fontSize: '12px', marginBottom: '30px' }}>
          <div className="mb-4" style={{ display: 'grid'  }}>
            <label htmlFor="paymentMethod" style={{textAlign:'left'}} className="block  font-medium mb-2">
              Preferred payment method:
            </label>
            <select
              id="paymentMethod"
              style={{ padding: "5px 40px", backgroundColor: 'F5F5F5', border: 'solid', borderWidth: '0.2px', borderColor: '#D3D3D3', marginRight: '5px' }}

              name="paymentMethod"
              className="w-full p-2 border rounded-lg"
              value={formData.paymentMethod}
              onChange={handleInputChange}
            >
              <option value="">Select Payment Method</option>
              <option value="paypal">PayPal ($10 minimum)</option>
              <option value="check">Check</option>
            </select>
          </div>
          <div className="mb-4" style={{ display: 'grid' }}>
            <label htmlFor="email" className="block text-sm font-medium mb-2">
              PayPal Account (Email):
            </label>
            <input
              type="email"
              style={{ color: 'F8F8F8', padding: "5px 40px", backgroundColor: 'F5F5F5', border: 'solid', borderWidth: '0.2px', borderColor: '#D3D3D3', marginRight: '5px' }}

              id="email"
              name="email"
              className="w-full p-2 border rounded-lg"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="Enter your PayPal email"
            />
          </div>
        </div>



        <div style={{ display: 'flex', gap: '110px' }}>
          <div className="mb-4" style={{ display: 'grid' }}>
            <label htmlFor="address" className="block text-sm font-medium mb-2" style={{ fontSize: '12px' }}>
              Street Address:
            </label>
            <textarea
              id="address"
              name="address"
              style={{ height: '200px', width: '240px', backgroundColor: 'F5F5F5' }}
              className="w-full p-2 border rounded-lg"
              value={formData.address}
              onChange={handleInputChange}
              placeholder="Enter your street address"
            />
          </div>


          <div style={{ fontSize: '12px' }}>
            <div className="grid grid-cols-2 gap-4 mb-4" style={{ marginBottom: '20px' }}>
              <div style={{ display: 'grid', marginBottom: '20px' }}>
                <label htmlFor="country" className="block text-sm font-medium mb-2">
                  Country:
                </label>
                <select
                  id="country"
                  name="country"
                  style={{ color: 'F8F8F8', padding: "5px 40px", backgroundColor: 'F5F5F5', border: 'solid', borderWidth: '0.2px', borderColor: '#D3D3D3', marginRight: '5px' }}

                  className="w-full p-2 border rounded-lg"
                  value={formData.country}
                  onChange={handleInputChange}
                >
                  <option value="">Select Country</option>
                  <option value="usa">USA</option>
                  <option value="canada">Canada</option>
                  <option value="uk">UK</option>
                </select>
              </div>
              <div style={{ display: 'grid' }}>
                <label htmlFor="state" className="block text-sm font-medium mb-2">
                  State:
                </label>
                <input
                  type="text"
                  id="state"
                  style={{ color: 'F8F8F8', padding: "5px 40px", backgroundColor: 'F5F5F5', border: 'solid', borderWidth: '0.2px', borderColor: '#D3D3D3', marginRight: '5px' }}

                  name="state"
                  className="w-full p-2 border rounded-lg"
                  value={formData.state}
                  onChange={handleInputChange}
                  placeholder="State"
                />
              </div>
            </div>
            <div className="mb-4" style={{ display: 'grid' }}>
              <label htmlFor="zipCode" className="block text-sm font-medium mb-2">
                Zip Code:
              </label>
              <input
                type="text"
                id="zipCode"
                style={{ color: 'F8F8F8', padding: "5px 40px", backgroundColor: 'F5F5F5', border: 'solid', borderWidth: '0.2px', borderColor: '#D3D3D3', marginRight: '5px' }}

                name="zipCode"
                className="w-full p-2 border rounded-lg"
                value={formData.zipCode}
                onChange={handleInputChange}
                placeholder="Zip Code"
              />
            </div>
          </div>
        </div>


        <div style={{ textAlign: 'center', marginTop: '10px' }}>
          <button
            type="submit"
            style={{ padding: '6px 40px', backgroundColor: '#1365A2', color: '#F5F5F5F5', borderColor:'transparent' }}
            className="w-full bg-blue-500 text-white py-2 rounded-lg hover:bg-blue-600"
          >
            Next
          </button>
        </div>


      </form>
    </div>
  );
};

export default ReferralForm;
